<template>
  <router-view></router-view>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'

export default {
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(locale) {
        this.applyDocumentLanguage(locale);
      }
    }
  },
  methods: {
    ...mapActions([
      'apiResources'
    ]),
    applyDocumentLanguage(locale) {
      const currentLocale = locale || 'en';
      document.documentElement.setAttribute('lang', currentLocale);
      if (document.body) {
        document.body.classList.toggle('lang-ar', currentLocale === 'ar');
      }
    },
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    }
  },
  mounted() {
    this.initializeLayout();
    this.apiResources();
  }
};
</script>
